import { render, staticRenderFns } from "./forget-password.vue?vue&type=template&id=11a09efd&scoped=true&"
import script from "./forget-password.vue?vue&type=script&lang=js&"
export * from "./forget-password.vue?vue&type=script&lang=js&"
import style0 from "./forget-password.vue?vue&type=style&index=0&id=11a09efd&prod&lang=scss&"
import style1 from "./forget-password.vue?vue&type=style&index=1&id=11a09efd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a09efd",
  null
  
)

export default component.exports